import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgExchangeSolid = function SvgExchangeSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        d: "m8.952 11.019-.088-.072a.82.82 0 0 0-1.025.072l-.46.437V7.543h5.245v3.914l-.538-.437-.088-.073a.82.82 0 0 0-1.065.112.72.72 0 0 0-.19.514c.007.188.09.367.23.5l1.88 1.707.088.073a.82.82 0 0 0 1.024-.073l1.805-1.708.076-.083a.716.716 0 0 0-.076-.97l-.089-.072a.82.82 0 0 0-1.023.073l-.461.435V6.798l-.007-.1a.74.74 0 0 0-.262-.461.8.8 0 0 0-.518-.184l-.02.003h-2.602l-.195-.003.195.007c-.026-.179.174.111.03-.007h-.524c-.189.024-.524 0-.524.003 0-.003-.525-.003 0-.003H6.593l-.107.007a.8.8 0 0 0-.487.248.72.72 0 0 0-.194.49v4.659l-.462-.436-.087-.073a.82.82 0 0 0-1.065.112.72.72 0 0 0-.19.514c.007.188.09.367.23.5l1.803 1.707.089.073a.82.82 0 0 0 1.025-.073l1.804-1.708.075-.083a.717.717 0 0 0-.075-.971"
    })));
};

export { SvgExchangeSolid as ReactComponent };
//# sourceMappingURL=ExchangeSolid.svg.es.js.map
